import SelectFormField from 'components/molecules/SelectFormField/SelectFormField';
import { ReportFooterType } from 'generated/graphql';
import { TSelectFormFieldValue } from 'interfaces/forms/form';
import { FC } from 'react';

const options = [
  { label: 'Default (Spotted Zebra branding)', value: ReportFooterType.Default },
  { label: 'Simple (no Spotted Zebra branding)', value: ReportFooterType.Simple },
];

interface IReportFooterTypeFormField {
  id: string;
  name: string;
  value: TSelectFormFieldValue;
  label: string;
  onChange: (value: TSelectFormFieldValue, name: string) => void;
  hasError?: boolean;
  errorText?: string | undefined;
  isDisabled?: boolean;
}

const ReportFooterTypeFormField: FC<IReportFooterTypeFormField> = ({
  ...selectElementProps
}) => <SelectFormField options={options} {...selectElementProps} />;

export default ReportFooterTypeFormField;
